import { Badge } from "@/components/ui/badge";

export default function ProceduresBlock({ data, testId }) {
    return (
        <div data-testid={testId} className="space-y-3 text-sm">
            <div className="flex flex-wrap gap-2">
                <Badge className={`rounded-full border-transparent shadow-sm ${data.entreprise_cessee ? "bg-rose-100 text-rose-800" : "bg-emerald-100 text-emerald-800"}`}>
                    {data.entreprise_cessee ? `Cessée${data.date_cessation ? ` le ${data.date_cessation}` : ""}` : `Statut : ${data.statut_consolide || "actif"}`}
                </Badge>
                <Badge className={`rounded-full border-transparent shadow-sm ${data.procedure_en_cours ? "bg-amber-100 text-amber-800" : "bg-muted text-muted-foreground"}`}>
                    {data.procedure_en_cours ? "Procédure collective en cours" : "Aucune procédure collective en cours"}
                </Badge>
            </div>
            {data.procedures.length > 0 ? (
                <ul className="divide-y divide-border rounded-xl border border-slate-200 bg-white shadow-sm">
                    {data.procedures.map((p) => (
                        <li key={`${p.type}-${p.date_debut}-${p.date_fin}-${p.tribunal}`} data-testid="procedure-item" className="px-4 py-2.5 flex flex-wrap items-center gap-x-4 gap-y-1">
                            <span className="font-medium text-foreground">{p.type || "Procédure"}</span>
                            <span className="text-muted-foreground">
                                {p.date_debut ? `du ${p.date_debut}` : ""} {p.date_fin ? `au ${p.date_fin}` : p.en_cours ? "· en cours" : ""}
                            </span>
                            {p.tribunal && <span className="text-xs text-muted-foreground">{p.tribunal}</span>}
                        </li>
                    ))}
                </ul>
            ) : (
                <p className="text-muted-foreground">Aucune procédure collective historisée (BODACC).</p>
            )}
        </div>
    );
}
